import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private router: Router
  ) {
  }

  //reload 
  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
      })
    })
  }

  //generate unique id
  generate_uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var uuid = Math.random() * 16 | 0, v = c == 'x' ? uuid : (uuid & 0x3 | 0x8);
      return uuid.toString(16);
    });
  }

  //years dropdown
  private startYear = 2023;
  private endYear = 2030;

  getYearRange(): number[] {
    const years: number[] = [];
    for (let year = this.startYear; year <= this.endYear; year++) {
      years.push(year);
    }
    return years;
  }

  updateYearRange(selectedYear: number): number[] {
    this.startYear = selectedYear + 1;
    this.endYear = this.startYear + 7;
    return this.getYearRange();
  }


  //
  private refreshGridSubject = new BehaviorSubject<boolean>(false);
  refreshGrid$ = this.refreshGridSubject.asObservable();

  triggerGridRefresh() {
    this.refreshGridSubject.next(true);
  }


}
